module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "milestones"
  }, [_c('div', {
    staticClass: "milestones__header"
  }, [_vm._v("Significant events in my journey")]), _vm._v(" "), _c('div', {
    staticClass: "milestone"
  }, [_c('div', {
    staticClass: "milestones__title"
  }, [_vm._v("Portfolio")]), _vm._v(" "), _c('div', {
    staticClass: "milestones__description"
  }, [_vm._v("To showcase my profile, skills, and experiences to the world, and to mess with new new technologies.")]), _vm._v(" "), _c('a', {
    staticClass: "milestones_link",
    attrs: {
      "href": "https://andoshin11.github.io/",
      "target": "_blank"
    }
  }, [_vm._v("https://andoshin11.github.io/")]), _vm._v(" "), _c('div', {
    staticClass: "milestones__skills skills"
  }, [_c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("ES6")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Vue.js")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("vue-cli")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("vue-router")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("GitHub Pages")])]), _vm._v(" "), _c('div', {
    staticClass: "work__images"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e0e5aac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Milestones.vue
// module id = 24
// module chunks = 0